/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../split-pane/split-pane";
import * as i2 from "./nav";
import * as i3 from "../../navigation/view-controller";
import * as i4 from "../../navigation/nav-controller";
import * as i5 from "../app/app";
import * as i6 from "../../config/config";
import * as i7 from "../../platform/platform";
import * as i8 from "../../gestures/gesture-controller";
import * as i9 from "../../transitions/transition-controller";
import * as i10 from "../../navigation/deep-linker";
import * as i11 from "../../platform/dom-controller";
var styles_Nav = [];
var RenderType_Nav = i0.ɵcrt({ encapsulation: 2, styles: styles_Nav, data: {} });
export { RenderType_Nav as RenderType_Nav };
export function View_Nav_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { _vp: 0 }), (_l()(), i0.ɵeld(1, 16777216, [[1, 3], ["viewport", 1]], null, 0, "div", [["nav-viewport", ""]], null, null, null, null, null)), (_l()(), i0.ɵeld(2, 0, null, null, 0, "div", [["class", "nav-decor"]], null, null, null, null, null))], null, null); }
export function View_Nav_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "ion-nav", [], null, null, null, View_Nav_0, RenderType_Nav)), i0.ɵprd(6144, null, i1.RootNode, null, [i2.Nav]), i0.ɵdid(2, 4374528, null, 0, i2.Nav, [[2, i3.ViewController], [2, i4.NavController], i5.App, i6.Config, i7.Platform, i0.ElementRef, i0.NgZone, i0.Renderer, i0.ComponentFactoryResolver, i8.GestureController, i9.TransitionController, [2, i10.DeepLinker], i11.DomController, i0.ErrorHandler], null, null)], null, null); }
var NavNgFactory = i0.ɵccf("ion-nav", i2.Nav, View_Nav_Host_0, { color: "color", mode: "mode", swipeBackEnabled: "swipeBackEnabled", root: "root", rootParams: "rootParams", name: "name" }, {}, []);
export { NavNgFactory as NavNgFactory };
//# sourceMappingURL=nav.ngfactory.js.map


// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/nav/nav.ngfactory.js.pre-build-optimizer.js